// 职业规划
import React from 'react'
import { Button } from 'antd';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';

import WidgetInput from '../../widget/WidgetInput';
import WidgetListTable from '../../widget/WidgetListTable';
import WidgetLabelSelect from '../../widget/WidgetLabelSelect';

import { checkLogin } from '../../pages/com/utils';

let filePath = Config.getFilePath();

class CareerSeek extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),

            labelDatas:[
                {label:"计算机/互联网/人工智能", value:"1"},
                {label:"电子/电气/通信", value:"2"},
                {label:"产品", value:"3"},
                {label:"客服/运营", value:"4"},
                {label:"销售", value:"5"},
                {label:"人力/行政/法务", value:"6"},
                {label:"财务/审计/税务", value:"7"},
                {label:"生产制造/普工/技工", value:"8"},
                {label:"物流/仓储/司机", value:"9"},
                {label:"酒店/旅游/餐饮", value:"10"},
                {label:"零售/生活服务", value:"11"},
                {label:"教育培训", value:"12"},
                {label:"房地产/建筑", value:"13"},
                {label:"直播/影视/传媒", value:"14"},
                {label:"市场/公关/广告", value:"15"},
                {label:"采购/贸易", value:"16"},
                {label:"咨询/翻译/法律", value:"17"},
                {label:"金融", value:"18"}
            ],
            data:[
                {id:"1", hot:true, imgPath:"test2.png", title:"大数据工程技术开发", description:"将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。", bookmarks:12, thumbUps:12 },
                {id:"2", hot:false, imgPath:"test.png", title:"大数据工程技术开发", description:"将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。", bookmarks:12, thumbUps:12 },
                {id:"3", hot:false, imgPath:"test3.png", title:"大数据工程技术开发", description:"将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。", bookmarks:12, thumbUps:12 }


            ],
            page:1,
            pageSize:10,
            total:3,
            loading:false
        }
    }


    loadData = () => {

    }

    notify = ( type, item) => {

        switch( type )
        {
            case "click":
            {
                
                
                break;
            }
            case "career-evaluation":
            {
                 if( checkLogin() ) 
                {
                    this.props.history.push({pathname:"/home/career-evaluation"})
                }
                else
                {
                    this.props.history.push({pathname:"/login?redirectURL=/home/career-evaluation"});
                    window.location.reload(); 
                }
            }
        }
    }

    pageTurning = (page, pageSize) => {
        this.setState({page:page, pageSize:pageSize}, () => {
            this.loadData();
        })
    }

    onChange = ( value ) => {

    }

    render()
    {
        const {sourcePath, labelDatas=[], data=[], page=1, total=0, pageSize=10, loading } = this.state;

         return (
            <div className="sf-page" component-data="career-seek">
                <div className='sf-career-top' >
                    <div className='sf-career-top-body'>
                        <div className='sf-career-top-body-content'>
                            <div className='sf-career-top-body-content-entrance'>
                                <div className='sf-career-top-body-item sf-career-seek-top-body-item'>
                                    {/* <img src={require('./../../img/' + sourcePath + '/career/seek-line.png')}></img> */}
                                    <div className='sf-page-title-font'>找工作的你可知自己适合</div>
                                </div>
                                
                                <div className='sf-career-top-body-item sf-second'>
                                    <div className='sf-page-title-font'>什么职业吗？</div>
                                    {/* <img src={require('./../../img/' + sourcePath + '/career/target.png')}></img> */}
                                </div>

                                <div className='sf-button-bg'>
                                    <div className='sf-career-top-body-start-button sf-start-button' onClick={() => {this.notify("career-evaluation")}}>去做职业兴趣测试</div>
                                </div>
                            </div>

                            <div className='sf-career-top-body-right'>
                                <img src={require('./../../img/' + sourcePath + '/career/career-seek-logo.png')} alt=""></img>
                            </div>
                        </div>
                    </div>

                    <div className='sf-career-bottom'>
                        <div className='sf-career-seek-title'>
                            <img src={require('./../../img/' + sourcePath + '/career/seek-title-icon.png')} alt=""></img>
                            <span>探索你更多感兴趣的职业</span>
                        </div>

                        <div className='sf-career-seek-search'>
                            <WidgetInput placeholder="请输入职业" onChange={ this.onChange }  suffix="" ></WidgetInput>
                            <Button type="primary">搜索</Button>
                        </div>

                        <div className='sf-career-seek-search-body'>
                            <div className='sf-career-seek-search-content'>
                                <div className='sf-career-seek-search-content-label'>
                                    <WidgetLabelSelect isTitleSelect={true} title="行业分类" data={labelDatas}></WidgetLabelSelect>
                                </div>

                                <div className='sf-career-seek-search-content-body'>
                                    <WidgetListTable loading={loading} data={data} total={total} page={page} notify={this.notify} pageTurning={this.pageTurning} pageSize={pageSize}></WidgetListTable>
                                </div>
                                
                            </div>

                            <div className='sf-career-seek-search-body-right'>
                                <div className='sf-career-title'>
                                    <div className='sf-vertical-line'></div>
                                    <span>我的专业有哪些就业职位</span>
                                </div>

                                <div className='sf-career-sub-title'>
                                    <div className='sf-career-sub-title-font'>教育经历</div>
                                    <div className='sf-career-sub-title-edit'><img alt="" src={require('./../../img/' + sourcePath + '/career/edit.png')}></img><span>编辑</span></div>
                                </div>

                                <div className='sf-person-edu'>
                                    <div className='sf-person-edu-item'>
                                        <div className='sf-person-edu-item-title'>某某某大学院</div>
                                        <div className='sf-person-edu-item-value'>2004/9-2008/7</div>
                                    </div>
                                    <div className='sf-person-edu-item'>
                                        <div className='sf-person-edu-item-title'>专业</div>
                                        <div className='sf-person-edu-item-value'>计算机科学与技术</div>
                                    </div>
                                    <div className='sf-person-edu-item'>
                                        <div className='sf-person-edu-item-title'>学位</div>
                                        <div className='sf-person-edu-item-value'>本科</div>
                                    </div>
                                    <div className='sf-person-edu-item'>
                                        <div className='sf-person-edu-item-title'>主修课程</div>
                                        <div className='sf-person-edu-item-value'>主修平面设计,设计心理学产品设计,包装设计,cdr,企业形象设计,展示设计,动画,角色设计,网页设计</div>
                                    </div>
                                </div>

                                <div className='sf-career-position-content'>
                                    <div className="sf-career-position">
                                        <div className='sf-career-position-title-box'>
                                            <div className='sf-career-position-title sf-font'>
                                                <div>软件销售</div>
                                            </div>
                                        </div>
                                        <div className='sf-career-position-body'>

                                            <div className='sf-career-position-body-content'>
                                                <span>将软件产品销售给客户，并满足客户需求的过程。软件销售人员需要了解客户的需求，并向他们介绍适合的产品。</span>
                                            </div>
                                            

                                            <div className='sf-career-position-footer'>
                                                <div className='sf-career-position-left'>
                                                    <img alt="" src={require('./../../img/' + sourcePath + '/career/promotion.png')}></img>
                                                    <span>可晋升方向</span>
                                                </div>
                                                <div className='sf-career-position-right'>
                                                    7
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                    </div>  
                </div>

                

            </div> 
        )
    }
}

export default CareerSeek